<template>
  <SimpleFieldDate
    :disabled="disabled"
    :operators="operators"
    :value.sync="mutableValue"/>
</template>
<script>
import SimpleFieldDate from 'components/automation/conditions/default/simpleFieldDate.vue'
/**
 * 5
 */
export default {
  name: 'publishFromDate',
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  components: {
    SimpleFieldDate
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
